import React from 'react';

import { getBarberDetail } from 'actions';
import { BarberProfilesConsumer } from '../context/barberProfiles';
import { setBarberProfiles as barberProfilesSetter } from '../reducers/barberProfilesReducer';

const BarberProfilesHook = (BaseComponent) => (props) => {
  const [barberProfilesConsumer, dispatch] = BarberProfilesConsumer();
  const barberProfiles = barberProfilesConsumer.profiles || {};

  const setBarberProfiles = (data) => {
    dispatch(barberProfilesSetter(data));
  };

  const getBarberProfile = (username) => {
    return new Promise((resolve, reject) => {
      if (barberProfiles[username]) {
        return resolve(barberProfiles[username]);
      } else {
        getBarberDetail(username)
          .then((response) => {
            const { data } = response;
            barberProfiles[username] = data;
            setBarberProfiles(barberProfiles);
            resolve(data);
          })
          .catch((_err) => {
            reject();
          });
      }
    });
  };

  return <BaseComponent {...props} barberProfiles={barberProfiles} setBarberProfiles={setBarberProfiles} getBarberProfile={getBarberProfile} />;
};

export default BarberProfilesHook;
